import React, { useMemo } from 'react';
import clsx from 'clsx';
import { useDropzone } from 'react-dropzone';

import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';

import styles from './DropZone.module.scss';

export default function DropZone({
  children,
  onDropFiles,
  disabled = false,

  accept = undefined,
  multiple = true,
  maxFiles = undefined,

  showBackdrop = true,

  className,
  overlayClassName,
}) {
  const dzOptions = useMemo(
    () => ({
      disabled,
      accept,
      multiple,
      maxFiles,
      noClick: true,
      noKeyboard: true,
      onDrop: (acceptedFiles) => {
        if (!acceptedFiles?.length) return;
        onDropFiles?.(acceptedFiles);
      },
    }),
    [disabled, accept, multiple, maxFiles, onDropFiles],
  );

  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone(dzOptions);

  return (
    <div {...getRootProps()} className={clsx(styles.root, className)}>
      <input {...getInputProps()} />

      {children}

      <div
        className={clsx(
          styles.overlay,
          isDragActive && styles.overlayActive,
          isDragReject && styles.overlayReject,
          overlayClassName,
        )}
        aria-hidden={!isDragActive}>
        {showBackdrop ? <div className={styles.backdrop} /> : null}

        <div className={styles.icon}>
          {isDragReject ? (
            <InsertDriveFileOutlinedIcon fontSize='inherit' />
          ) : (
            <FileUploadOutlinedIcon fontSize='inherit' />
          )}
        </div>
      </div>
    </div>
  );
}
